import React from 'react'
// components
import InjuryMasterMapping from '../InjuryMasterMapping'

interface Props {
  field: string
}

const CreateParentCase: React.FC<Props> = ({ field }) => (
  <InjuryMasterMapping
    isCreate
    field={field}
    withParentFields
    description="Creates the Injury Master incident of this record's parent, once, filled from the fields of this form or of its parent. Person and Cost centre are required, they must already be synced to Injury Master."
  />
)

export default CreateParentCase
